// src/components/Layout.tsx
import React from "react";
import Sidebar from "../sidebar/Sidebar";
import Topbar from "../topbar/TopBar";
interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <Topbar />
      <div className="flex flex-1 pt-16 pl-28 sm:pl-64">
        <Sidebar />
        <main className="flex-1 p-2">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
